import Distribution from "../distribution.vue";
import Imports from '../components/imports/imports.vue';
import AccountList from '../components/accounts/account-list.vue';
import OrderList from '../components/orders/order-list.vue';
import ReportsComponent from '../components/reports/reports.vue';
import ReportsMainComponent from '../components/reports/reports-main.vue';
import ReportsSummarizedComponent from '../components/reports/report-summarized.vue';
import SupplierList from '../components/suppliers/supplier-list.vue';
import SupplierOrderList from '../components/supplier_orders/supplier-order-list.vue';
import SalesList from '../components/sales/sales.vue';
import DistributionStatementList from '../components/statement_list/statement-list.vue';
import ShopList from '../components/shops/shops-list.vue';
import Shop_groupsList from '../components/shop_groups/shop_groups-list.vue';
import DistributionPlugin from '../components/plugin/plugin';
import ReleaseReportList from '../components/release_report/release-report-list.vue';
import DistributionDashboard from '../components/dashboard/distribution-dashboard.vue';
import { getDetailsTabRouteObjects } from '../../../utility/route';

import {
  distributionAccountListLDTRoutes,
  distributionOrderListLDTRoutes,
  distributionSalesListLDTRoutes,
  distributionSupplierListLDTRoutes,
  distributionSupplierOrderListLDTRoutes,
  distributionStatementListLDTRoutes,
  distributionShopListLDTRoutes,
  distributionShop_groupListLDTRoutes
} from './routes';

export default [
  {
    path: "/main/distribution",
    name: "distribution",
    component: Distribution,
    redirect: "main/distribution/imports",
    children: [
      {
        name: 'imports',
        path: "imports",
        component: Imports
      },
      ...getDetailsTabRouteObjects(distributionAccountListLDTRoutes, AccountList),
      ...getDetailsTabRouteObjects(distributionOrderListLDTRoutes, OrderList),
      ...getDetailsTabRouteObjects(distributionSupplierListLDTRoutes, SupplierList),
      ...getDetailsTabRouteObjects(distributionStatementListLDTRoutes, DistributionStatementList),
      ...getDetailsTabRouteObjects(distributionShopListLDTRoutes, ShopList),
      ...getDetailsTabRouteObjects(distributionShop_groupListLDTRoutes, Shop_groupsList),
      ...getDetailsTabRouteObjects(distributionSupplierOrderListLDTRoutes, SupplierOrderList),
      // {
      //   name: 'reports',
      //   path: "reports",
      //   component: ReportsComponent
      // },

      {
        name: 'reports_with_tabId',
        path: 'reports/:tabId',
        component: ReportsComponent,

      },
      {
        name: 'reports',
        path: 'reports',
        component: ReportsComponent,

      },
      {
        name: 'dashboard',
        path: 'dashboard',
        component: DistributionDashboard,

      },
      {
        name: 'release_report',
        path: 'release_report',
        component: ReleaseReportList,

      },

      {
        name: 'distribution_plugins',
        path: "plugins",
        component: DistributionPlugin
      },
    ],

  }
];
